export default "__VITE_ASSET__02618d5e__"